export default "__VITE_ASSET__yjTs4VBU__"